import React, { useState, useRef, useEffect } from 'react';
import styles from './CreateCouncilMember.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import newsAdded from '../../../../assets/Imagess/news-added.png';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import DatePicker from 'react-datepicker';
import ReactQuill from 'react-quill';
import '../../../../styles/Quill.css';
import '../../../../styles/DatePicker.css';
import 'react-quill/dist/quill.snow.css';
import { useFetchNewsCategories } from '../../../../Hooks/News';
import moment from 'moment';
import { useFetchCouncilNewsById } from '../../../../Hooks/Council';
import TextInput from '../../../Atoms/Inputs/TextInput';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import Loader from '../../../Molecules/Loader/Loader';

import he from 'he';
import DateInput from '../../../Atoms/Inputs/DateInput';

const UpdateCouncilNews = () => {
  const { id, type } = useParams();
  const fileInputRef = useRef(null);
  const customizedToast = useToast();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const [imageSrc, setImageSrc] = useState('');
  const { data: newsCategories } = useFetchNewsCategories();
  const {
    data: councilNews,
    isLoading,
    refetch: refetchCouncilNews,
  } = useFetchCouncilNewsById(id);

  const calendarIcon = (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Group 20956'>
        <path
          id='Vector'
          d='M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z'
          fill='#A9A7A7'
        />
        <path
          id='Vector_2'
          d='M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z'
          fill='#A9A7A7'
        />
      </g>
    </svg>
  );

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetchCouncilNews();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(councilNews)) {
      const newsData = councilNews.data;
      formikRef.current.setValues({
        name: newsData.title_EN || '',
        nameAr: newsData.title_AR || '',
        category: newsData.categoryId || '',
        postedDate: newsData.newsDate
          ? new Date(newsData.newsDate)
          : new Date(),
        description: newsData.newsTextEn || '',
        descriptionAr: newsData.newsTextAr || '',
      });
      setImageSrc(`${councilNews?.data?.url}${councilNews?.data?.image}`);
    }
  }, [councilNews]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    nameAr: Yup.string().required('Arabic name is required'),
    postedDate: Yup.date().required('Posted date is required'),
    category: Yup.string().required('Category is required'),
    description: Yup.string().required('Description is required'),
    descriptionAr: Yup.string().required('Arabic description is required'),
    image:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Image is required'),
  });

  const createNews = useMutation({
    mutationFn: (fields) => {
      return axios.post(
        API_URL + `/api/Council/CouncilNews`,
        fields,

        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: () => {
      customizedToast.open(
        id ? 'تم تحديث أخبار المجلس بنجاح ' : 'تم إنشاء أخبار المجلس بنجاح '
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(
          `/home/council/${
            type == 0
              ? 'students'
              : type == 1
              ? 'parents'
              : type == 2
              ? 'cadets-students'
              : type == 3
              ? 'faculty-members'
              : 'council-calendar'
          }`,
          {
            state: { selectedActivity: true },
          }
        );
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    const newsId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('NewsId', newsId);
    formData.append('AcademicYearId', '62B02A29-E9D2-463D-93EB-A75622983565');
    formData.append('CouncilType', type);
    formData.append('TitleEn', values.name);
    formData.append('TitleAr', values.nameAr);
    if (undefined !== values.image) {
      formData.append('Image', values.image);
    }
    formData.append('Date', moment(values.postedDate).format('YYYY-MM-DD'));
    formData.append('NewsTextEn', values.description);
    formData.append('NewsTextAr', values.descriptionAr);
    formData.append('CategoryId', values.category);
    createNews.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'تحديث الأخبار' : 'إنشاء خبر'}
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            name: councilNews?.data.title_EN || '',
            nameAr: councilNews?.data.title_AR || '',
            category: councilNews?.data.categoryId || '',
            postedDate: councilNews?.data.newsDate
              ? new Date(councilNews?.data.newsDate)
              : '',
            description: councilNews?.data.newsTextEn || '',
            descriptionAr: councilNews?.data.newsTextAr || '',
            image: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['steps']}>
                <div className={styles['step-container']}>
                  <TextInput
                    label='News Title'
                    placeholder='Enter Title'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.name}
                    touched={touched.name}
                    value={values.name}
                    name='name'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                </div>
                <div className={`${styles['step-container']} ${styles['rtl']}`}>
                  <TextInput
                    label='عنوان الخبر'
                    placeholder='أدخل عنوان الخبر'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                      marginBottom: '26px',
                    }}
                    containerStyle={{
                      padding: '0px',
                      justifyContent: 'flex-start',
                    }}
                    name='nameAr'
                    value={values.nameAr}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    onChange={(name, value) => setFieldValue(name, value)}
                  />
                </div>
                <div
                  className={styles['step-container']}
                  style={{ marginTop: '26px' }}
                >
                  <div className={styles['step-row']}>
                    <CustomSelect
                      label='Category Name'
                      placeholder='Select Type'
                      icon={folderIcon}
                      style={{ width: '100%' }}
                      iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                      dropdownStyle={{ height: '62px', marginTop: '4px' }}
                      value={values.category}
                      onChange={(e) => setFieldValue('category', e.value)}
                      selectedTextKey='category_EN'
                      options={newsCategories?.data?.map((option) => ({
                        value: option.newsCategoryId,
                        text: option.category_EN,
                      }))}
                      type='category'
                      touched={touched.category}
                      errors={errors.category}
                    />
                    <div style={{ width: '50%' }}>
                      <DateInput
                        label='تاريخ النشر'
                        placeholder='حدد التاريخe'
                        showIcon
                        value={values.postedDate}
                        name='postedDate'
                        onChange={setFieldValue}
                        dateFormat='yyyy-MM-dd'
                        errors={errors.postedDate}
                        touched={touched.postedDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className={styles['steps']}>
                  <div className={styles['quill-container']}>
                    <label className={styles['quill-label']}>
                      News Description
                    </label>
                    {errors.description && touched.description && (
                      <label className={styles['quill-error']}>required</label>
                    )}
                    <ReactQuill
                      value={values.description}
                      onChange={(value) =>
                        setFieldValue('description', he.decode(value))
                      }
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder='Write something...'
                    />
                  </div>
                  <div
                    className={`${styles['quill-container']} ${styles['rtl']}`}
                  >
                    <label className={styles['quill-label']}>وصف الخبر</label>
                    {errors.descriptionAr && touched.descriptionAr && (
                      <label className={styles['quill-error']}>required</label>
                    )}
                    <ReactQuill
                      value={values.descriptionAr}
                      onChange={(value) =>
                        setFieldValue('descriptionAr', he.decode(value))
                      }
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder='أدخل الوصف'
                    />
                  </div>
                </div>
              </div>
              {errors.image && (
                <div
                  className={styles['error-message']}
                  style={{ marginTop: '30px' }}
                >
                  <p>{errors.image}</p>
                </div>
              )}
              <div style={{ marginTop: '30px' }}>
                <label>رفع الصورة</label>
              </div>
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef.current.click()}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  accept='image/*'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={(event) =>
                    setFieldValue('image', event.currentTarget.files[0])
                  }
                />
                {values.image ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
              <button
                type='submit'
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateCouncilNews;
